import type { RouteRecordRaw } from 'vue-router'

const CommissionsPage = () => import('./pages/CommissionsPage.vue')

const commissionRoutes: RouteRecordRaw[] = [
  {
    name: 'finance-commissions',
    path: 'commissions',
    component: CommissionsPage,
    meta: { requiresAuth: true },
  },
]

export default commissionRoutes
